import * as yup from 'yup'
import { pick } from 'lodash'
export default channels =>
  yup.object({
    marketing: yup.object(
      pick(
        {
          email: yup.bool(),
          sms: yup.bool(),
          phone: yup.bool()
        },
        channels
      )
    )
  })
